if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.updateColorLabel();
      this.addEventListener('change', (event) => {
        this.updateColorLabel();
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
        // Mobile + Color swatch only: defer the gallery scroll until after the variant re-render.
        // Setting false for Size/other options clears any stale intent before their own re-render.
        this.pendingGalleryScroll =
          MinimogTheme.config.mqlMobile &&
          !!event.target.closest('[data-picker-type="color"], [data-picker-type="swatch_color"], [data-picker-type="default"]');
      });
      // Scroll once the product re-render has finished (media/price updated + focus restored),
      // so the final position is the gallery and nothing scrolls it back down afterwards.
      this.variantChangeUnsubscriber = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, () => {
        if (!this.pendingGalleryScroll) return;
        this.pendingGalleryScroll = false;
        requestAnimationFrame(() => this.scrollToGallery());
      });
    }

    disconnectedCallback() {
      this.variantChangeUnsubscriber?.();
    }

    // Show/refresh the selected value for color options only; leaves other options (e.g. Size) untouched.
    updateColorLabel() {
      this.querySelectorAll('[data-picker-type="color"], [data-picker-type="swatch_color"], [data-picker-type="default"]').forEach((option) => {
        const checked = option.querySelector('input[type="radio"]:checked');
        const label = option.querySelector('.option-label--selected');
        if (checked && label) label.textContent = checked.value;
      });
    }

    // Smoothly bring the product gallery into view, offset by the sticky header height.
    // Called after the variant re-render for a mobile Color change (see connectedCallback).
    scrollToGallery() {
      const media = (this.closest('.m-main-product--wrapper') || document).querySelector('.m-main-product--media');
      if (!media) return;
      const header = document.querySelector('.m-header__wrapper');
      const offset = header ? header.offsetHeight : 0;
      const top = media.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}